import { useEffect, useRef } from 'react';

export function useEscapeKey(isOpen: boolean, handler?: () => void): void {
  const handlerRef = useRef(handler);

  useEffect(() => {
    handlerRef.current = handler;
  }, [handler]);

  useEffect(() => {
    if (!isOpen) {
      return;
    }

    function onKeyDown(e: KeyboardEvent) {
      if (e.key === 'Escape') {
        handlerRef.current?.();
      }
    }

    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [isOpen]);
}
